export function BrandLogo({ dealer, showText = true, className = "", compact = false }) {
  const name = dealer?.name || "Dealership";
  const parts = name.split(" ");
  const primary = parts[0] || name;
  const secondary = parts.slice(1).join(" ");
  const size = compact ? 34 : 42;

  if (dealer?.logo_url) {
    return (
      <div className={`flex items-center gap-3 ${className}`} data-testid="dealer-brand-logo">
        <img
          src={dealer.logo_url}
          alt={name}
          className={`${compact ? "h-8" : "h-10"} w-auto max-w-[180px] object-contain`}
        />
        {showText && !compact && (
          <div className="font-heading font-extrabold text-white tracking-tight text-lg hidden sm:block">{name}</div>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="dealer-brand-logo">
      <svg width={size} height={size} viewBox="0 0 100 100" className="shrink-0">
        <circle cx="50" cy="50" r="45" fill="none" stroke="rgb(var(--brand-rgb))" strokeWidth="4" />
        <circle cx="50" cy="50" r="45" fill="rgb(var(--brand-rgb))" opacity="0.08" />
        <rect x="6" y="43" width="88" height="14" rx="2" fill="rgb(var(--brand-rgb))" />
        <rect x="6" y="43" width="88" height="14" rx="2" fill="url(#g)" opacity="0.25" />
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#fff" stopOpacity="0.7" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
      {showText && (
        <div className="leading-none">
          <div className="font-heading font-extrabold text-white tracking-tight text-lg">{primary}</div>
          {secondary && (
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.35em] text-brand font-semibold">{secondary}</div>
          )}
        </div>
      )}
    </div>
  );
}
